import { Injectable } from '@angular/core';
import { ApiServiceBase } from '@api/abstracts';
import { KitchenPriceDetails } from '@components/popin-price-detail/models';

@Injectable({
  providedIn: 'root',
})
export class PopinPriceDetailService extends ApiServiceBase<KitchenPriceDetails> {
  constructor() {
    super('pricedetail');
  }
}
